import { render, staticRenderFns } from "./CompanyDetailsForm.vue?vue&type=template&id=619c833e&scoped=true"
import script from "./CompanyDetailsForm.vue?vue&type=script&lang=ts"
export * from "./CompanyDetailsForm.vue?vue&type=script&lang=ts"
import style0 from "./CompanyDetailsForm.vue?vue&type=style&index=0&id=619c833e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "619c833e",
  null
  
)

export default component.exports